import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { Popover } from 'antd';
import { RootStore } from '@/models';
import ActionBtn from '../ActionBtn';
import SettingPanel from '../../../SettingPanel';
import styles from './index.less';
import classNames from 'classnames';
import { elkLog } from '@/utils/elkReport';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  RTCInstance?: RootStore['rtc'];
}
const SettingBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
  };
})(
  observer((props) => {
    const { RTCInstance } = props;
    const [isSettingVisible, setIsSettingVisible] = React.useState(false);
    const { formatMessage } = useIntl();

    React.useEffect(() => {
      const cb = () => {
        setIsSettingVisible(false);
      };
      document.addEventListener('click', cb);
      RTCInstance?.getDeviceOptions(false);
      return () => {
        document.removeEventListener('click', cb);
      };
    }, []);

    return (
      <Popover
        overlayClassName="oj7YZbAO5p"
        placement="top"
        align={{ offset: [0, 12] }}
        content={<SettingPanel />}
        visible={isSettingVisible && !RTCInstance?.breakLineReconnecting}
      >
        <ActionBtn
          tooltip={formatMessage({ id: 'openSetting' })}
          title={formatMessage({ id: 'SETTINGS' })}
          className={classNames(styles.settingBtn, {
            [styles.disable]: RTCInstance?.breakLineReconnecting,
          })}
          onClick={(e) => {
            // e.nativeEvent.stopImmediatePropagation();
            elkLog('点击设置按钮');
            setTimeout(() => {
              if (RTCInstance?.breakLineReconnecting) {
                setIsSettingVisible(false);
                return;
              }
              setIsSettingVisible(!isSettingVisible);
            }, 1);
          }}
        >
          <Icon className={styles.icon} name="icon-setting" mode="symbol" size={24} />
        </ActionBtn>
      </Popover>
    );
  })
);

export default SettingBtn;
